import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * One sentence + one action — Salon Desk empty state pattern (Phase 8).
 *
 * @param {{
 *   icon?: import('react').ReactNode
 *   message: string
 *   actionLabel?: string
 *   onAction?: () => void
 *   actionHref?: string
 *   className?: string
 * }} props
 */
export function SalonEmptyState({
  icon = null,
  message,
  actionLabel,
  onAction,
  actionHref,
  className,
}) {
  const showAction = Boolean(actionLabel && (onAction || actionHref))

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 px-6 py-12 text-center',
        className,
      )}
    >
      {icon ? (
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          {icon}
        </div>
      ) : null}
      <p className="max-w-sm text-base text-muted-foreground">{message}</p>
      {showAction ? (
        onAction ? (
          <Button type="button" size="lg" className="rounded-2xl px-6" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : (
          <Button asChild size="lg" className="rounded-2xl px-6">
            {actionHref?.startsWith('/') ? (
              <Link to={actionHref}>{actionLabel}</Link>
            ) : (
              <a href={actionHref}>{actionLabel}</a>
            )}
          </Button>
        )
      ) : null}
    </div>
  )
}
